import { render } from "./OrderSearch.vue?vue&type=template&id=8d376862"
import script from "./OrderSearch.vue?vue&type=script&lang=js"
export * from "./OrderSearch.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mattday/Sites/swallowdental.co.uk/app/code/SwallowDental/CustomAccount/view/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"web/vue/components/OrderSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d376862"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d376862', __exports__)) {
    api.reload('8d376862', __exports__)
  }
  
  module.hot.accept("./OrderSearch.vue?vue&type=template&id=8d376862", () => {
    api.rerender('8d376862', render)
  })

}


export default __exports__